module.exports = "<app-header [collapsedSidebar]=\"collapsedSidebar\"></app-header>\n<!-- <app-side-menu (closeSideBar)=\"setSideBar($event)\"></app-side-menu> -->\n\n<div class=\"content-wrapper\" [ngClass]=\"{'collapsed': collapsedSidebar}\">\n  <div class=\"page-wrapper\">\n    <router-outlet></router-outlet>\n  </div>\n</div>\n\n<app-footer></app-footer>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/layout.component.html
// module id = ./src/app/layout/layout.component.html
// module chunks = main